export const JOURNEY_BALLS = ['us', 'customer', 'supplier', 'installer'];

export const JOURNEY_BALL_ICONS = {
  us: 'user',
  customer: 'clock',
  supplier: 'truck',
  installer: 'tool',
};

export const JOURNEY_PHASE_COLORS = {
  request: '#434f6f',
  proposal: '#3364e6',
  measurement: '#7c5cff',
  sold: '#16a34a',
  preparation: '#ff9500',
  execution: '#0ea5e9',
  closing: '#0d9488',
};

const TYPED_PROPOSAL_STEPS = [
  'send_proposal',
  'await_proposal_decision',
  'follow_up_proposal',
  'renew_proposal',
];

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Label for a journey next step; proposal steps name the quote type when the API provides it.
 */
export function journeyStepLabel($t, step) {
  if (!step) return '';
  if (step.proposal_type && TYPED_PROPOSAL_STEPS.includes(step.key)) {
    return $t(`journey.proposal_steps.${step.proposal_type}.${step.key}`);
  }
  return $t(`journey.steps.${step.key}`);
}

/**
 * Whole days since `since`; 0 for missing or future dates.
 */
export function journeyWaitingDays(since, now = Date.now()) {
  if (!since) return 0;
  const diff = now - new Date(since).getTime();
  return diff > 0 ? Math.floor(diff / DAY_MS) : 0;
}
